import React from 'react'
import { Modal, ModalBody } from "reactstrap"

const ViewPDFDocument = ({ docUrl, open, title, handleClose }) => {

    const handleDownload = (docUrl) => {
        if (typeof window !== "undefined" && docUrl) {
            const downloadLink = document.createElement("a")
            downloadLink.href = docUrl
            downloadLink.download = `${title || 'document'}.pdf`
            document.body.appendChild(downloadLink)
            downloadLink.click()
            downloadLink.remove()
        }
    }


    return (
        <Modal className="DocViewerModal" isOpen={open} toggle={() => handleClose()} fullscreen>
            <div className="DocViewerModalHeader">
                <p className="DocViewerModalTitle">
                    {title}
                </p>
                <div className="DocViewerModalActions">
                    <p><i className="fa fa-download" onClick={() => handleDownload(docUrl)}></i></p>
                    <p><i className="fa fa-times" onClick={() => handleClose()}></i></p>
                </div>
            </div>
            <ModalBody>
                <iframe scrolling="yes" className="DocViewerFrame" src={docUrl} />
            </ModalBody>
        </Modal>
    )
}

export default ViewPDFDocument